<template>
  <el-dialog
    title="协议配置列表"
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    :append-to-body="true"
    width="1300px"
    v-dialogDrag
  >
    <div class="float-right mb-10px">
      <!-- <el-button type="primary" @click="search">搜索</el-button> -->
      <el-button type="primary" class="!ml-10px" @click="addHandle">新增</el-button>
      <el-button type="danger" class="!ml-10px" @click="delHandle()" :disabled="!selectionList.length">删除</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      stripe
      height="430"
      v-loading="tableLoading"
      @selection-change="selectionChange"
    >
      <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column label="接入协议" show-overflow-tooltip prop="name" min-width="50">
        <template>
          {{detailRow.protocolTypeName}}
        </template>
      </el-table-column>
      <el-table-column label="设备厂商" show-overflow-tooltip prop="name" min-width="50">
        <template>
          {{detailRow.manufacturerName}}
        </template>
      </el-table-column>
      <el-table-column label="实例名称" show-overflow-tooltip prop="name" min-width="50"></el-table-column>
      <el-table-column v-for="(item, index) in tableHeader" :label="item.label" show-overflow-tooltip :prop="item.prop" :key="index" min-width="50"></el-table-column>
      <el-table-column label="操作" width="135">
        <template slot-scope="{row}">
          <el-button size="mini" @click.stop="editHandle(row)">编辑</el-button>
          <el-button size="mini" class="!ml-10px" @click.stop="delHandle(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px"
      background
      @size-change="getList"
      @current-change="getList"
      :current-page.sync="initPagination.pageNum"
      :page-size.sync="initPagination.pageSize"
      :total="initPagination.total"
      layout="->,total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>

    <ProtocolConfig v-if="editDialogShow" :show.sync="editDialogShow" :type="editType" :detailRow="selectRow" @reload="getList"></ProtocolConfig>
  </el-dialog>
</template>

<script>
import { IOTDeviceTemplateApi, IOTDeviceProtocolInstanceApi } from '@wiz-api/iot-device-management'
import ProtocolConfig from './protocolConfig'

const ioTdeviceManagementApi = new IOTDeviceTemplateApi()
const iOTDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()
export default {
  name: 'protocolConfigList',
  props: {
    show: Boolean,
    detailRow: Object,
  },
  components: {
    ProtocolConfig
  },
  data() {
    return {
      form: {},
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      tableHeader: [],
      tableData: [],
      tableLoading: false,
      selectionList: [],
      selectRow: {},
      editType: 'add',
      editDialogShow: false
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
    deviceTypeList() {
      return []
    },
  },

  methods: {
    selectionChange(val) {
      this.selectionList = val
    },
    addHandle() {
      this.editType = 'add'
      this.selectRow = {
        protocolTypeName: this.detailRow.protocolTypeName,
        manufacturerName: this.detailRow.manufacturerName,
        manufacturer: this.detailRow.manufacturer,
        protocolTypeCode: this.detailRow.protocolTypeCode,
      }
      this.editDialogShow = true
    },
    editHandle(row) {
      this.editType = 'edit'
      this.selectRow = {
        protocolTypeName: this.detailRow.protocolTypeName,
        manufacturerName: this.detailRow.manufacturerName,
        manufacturer: this.detailRow.manufacturer,
        protocolTypeCode: this.detailRow.protocolTypeCode,
        ...row,
      }
      this.editDialogShow = true
    },
    delHandle(row) {
      this.$confirm('是否删除', '提示', {
        confirmButtonText: '确定',
        cancelButtontext: '取消',
        closeOnClickModal: false,
        type: 'warning',
      }).then(async () => {
        let ids = []
        if (row) {
          ids = [row.id]
        } else {
          ids = this.selectionList.map((item) => {
            return item.id
          })
        }
        const [err] = await iOTDeviceProtocolInstanceApi.deleteMany({
          ids
        })
        if (!err) {
          this.$message.success('删除成功')
          this.getList()
        }
      })
    },
    async getList() {
      this.tableLoading = true
      const [err, res] = await iOTDeviceProtocolInstanceApi.getList({
        ...this.form,
        protocolCode: this.detailRow.protocolTypeCode,
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      })
      if (!err) {
        const tableData = []
        res.items.forEach((item) => {
          if (item.jsonContent) {
            const jsonData = JSON.parse(item.jsonContent)
            tableData.push({ ...item, ...jsonData })
          }
        })
        this.tableData = tableData || []
        this.initPagination.total = res.totalCount
      }
      this.tableLoading = false
    },
    search() {
      this.initPagination.pageNum = 1
      this.getList()
    },
    // 获取协议配置模板
    async getProtocolConfig() {
      const [err, res] = await ioTdeviceManagementApi.getIOTDeviceTemplateProtocolSystem({
        protocolTypeCode: this.detailRow.protocolTypeCode,
      })
      if (!err) {
        const tableHeader = []
        const json = JSON.parse(res)
        Object.keys(json).forEach((key) => {
          tableHeader.push({
            label: key,
            prop: key
          })
        })
        this.tableHeader = tableHeader
      }
      this.getList()
    }
  },
  created() {
    this.getProtocolConfig()
  },
}
</script>

<style lang="scss" scoped></style>
